/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LibSafeMathRichErrorsV061,
  LibSafeMathRichErrorsV061Interface,
} from "../LibSafeMathRichErrorsV061";

const _abi = [
  {
    inputs: [],
    name: "UINT256_BINOP_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UINT256_DOWNCAST_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum LibSafeMathRichErrorsV06_1.BinOpErrorCodes",
        name: "errorCode",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "b",
        type: "uint256",
      },
    ],
    name: "Uint256BinOpError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum LibSafeMathRichErrorsV06_1.DowncastErrorCodes",
        name: "errorCode",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
    ],
    name: "Uint256DowncastError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class LibSafeMathRichErrorsV061__factory {
  static readonly abi = _abi;
  static createInterface(): LibSafeMathRichErrorsV061Interface {
    return new utils.Interface(_abi) as LibSafeMathRichErrorsV061Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LibSafeMathRichErrorsV061 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LibSafeMathRichErrorsV061;
  }
}
